// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__i86T_","comment":"styles_comment__31zZn"};